let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c2yoy")).then(() => parcelRequire('dSNBY'));